// extracted by mini-css-extract-plugin
module.exports = {"CustomOverlay":"CustomWithSpinner_CustomOverlay__3VRuK","SpinnerContainer":"CustomWithSpinner_SpinnerContainer__2N0Gb"};